import { css } from '@emotion/react';
import { THEME } from '@anytag/shared-constants';
import { FilterAction } from '@anytag/shared-types';
import { getRestApiUrl } from '@anytag/shared-utils';
import { DownloadButton } from '@anytag/shared-atoms';
import { useDownloadFile } from '@anytag/shared-hooks';
import { DayPickerRange } from '@anytag/shared-molecules';
import { MarketplaceAffiliateReportFilterFormValues } from './schemaTypes';

export interface MarketplaceAffiliateReportFilterProps
  extends FilterAction<MarketplaceAffiliateReportFilterFormValues> {
  campaignId: number;
}
export const MarketplaceAffiliateReportFilter = ({
  filter,
  setFilter,
  campaignId
}: MarketplaceAffiliateReportFilterProps) => {
  const { downloading, handleDownloadFile } = useDownloadFile();

  return (
    <div css={styles.wrapper}>
      <DayPickerRange
        rangeList={[]}
        handleChangePeriod={setFilter}
        disabledRange={{ after: new Date() }}
        period={{ endDate: filter.endDate || '', startDate: filter.startDate || '' }}
      />
      <DownloadButton
        disabled={downloading}
        onClick={() =>
          handleDownloadFile({
            filenamePrefix: `report_by_${filter.mode}`,
            params: { endDate: filter.endDate, startDate: filter.startDate, showBy: filter.mode },
            url: getRestApiUrl(`report/campaign/marketplace/${campaignId}/affiliate_report/csv/`)
          })
        }
      />
    </div>
  );
};
const styles = {
  wrapper: css({
    gap: '8px',
    display: 'flex',
    padding: '16px',
    boxSizing: 'border-box',
    justifyContent: 'flex-end',
    backgroundColor: THEME.background.colors.white
  })
};
